import { PATH_NAME_MOVIE_18, PATH_NAME_SCHEDULE } from '@/common/resources/router.const'
import { UI_CODE } from '@/common/resources/const'
import { beforeGNBEnter } from '@/common/utils/common'

export default [
  {
    path: 'movie/ppv',
    name: PATH_NAME_MOVIE_18,
    meta: { uiCode: UI_CODE.MOVIE_18, section: PATH_NAME_MOVIE_18 },
    alias: '/movie/ppv/index.html',
    components: {
      bodyContent: () => import(/* webpackChunkName: "movie_ppv" */'@/pages/movie/ppv')
    },
    beforeEnter: beforeGNBEnter
  },
  {
    path: 'schedule',
    name: PATH_NAME_SCHEDULE,
    alias: '/schedule/index.html',
    components: {
      bodyContent: () => import(/* webpackChunkName: "schedule" */'@/pages/schedule/index')
    }
  }
]
